import React from 'react';
import PropTypes from 'prop-types';

import FTSection from '../FTSection';
import './styles.scss';

const FTGroup = ({
    classBlockName,
    group,
    setGlobalModal,
    changeSelectionOrder,
    isMobile,
    currencySign,
    setStake,
    setIsEditingStake,
    setMultiplesError,
    clearMultiplesError,
}) => {
    const optionIdsList = group.options.length > 0 ? group.options.map(
            option => option.optionId,
        ) :
        [];
    const hasBetOrdering = group.options.filter(option => (
        option.betType === 'straight-forecast' ||
        option.betType === 'straight-tricast'
    )).length > 0;

    return (
        <div className={`${classBlockName}`}>
            {group.selections.length > 0 ?
                <FTSection
                    classBlockAddon="selections"
                    data={group.selections}
                    optionIdsList={optionIdsList}
                    hasBetOrdering={hasBetOrdering}
                    setGlobalModal={setGlobalModal}
                    changeSelectionOrder={changeSelectionOrder}
                    isMobile={isMobile}
                    currencySign={currencySign}
                    setStake={setStake}
                    setIsEditingStake={setIsEditingStake}
                    setMultiplesError={setMultiplesError}
                    clearMultiplesError={clearMultiplesError}
                /> :
                null
            }
            {group.options.length > 0 ?
                <FTSection
                    classBlockAddon="options"
                    data={group.options}
                    setGlobalModal={setGlobalModal}
                    isMobile={isMobile}
                    currencySign={currencySign}
                    setStake={setStake}
                    setIsEditingStake={setIsEditingStake}
                    setMultiplesError={setMultiplesError}
                    clearMultiplesError={clearMultiplesError}
                /> :
                null
            }
        </div>
    );
}

FTGroup.defaultProps = {
    classBlockName: 'bs-ft-group',
    group: { selections: [], options: [] },
    isMobile: false,
    currencySign: '£',
    setStake: () => {},
    setIsEditingStake: () => {},
    changeSelectionOrder: () => {},
    setMultiplesError: () => {},
    clearMultiplesError: () => {},
};

FTGroup.propTypes = {
    classBlockName: PropTypes.string,
    group: PropTypes.shape({
        selections: PropTypes.arrayOf(
            PropTypes.shape({
                courseName: PropTypes.string,
                decimalPrice: PropTypes.number,
                eachWayFraction: PropTypes.string,
                eachWayPlaces: PropTypes.string,
                eventId: PropTypes.string,
                feed: PropTypes.string,
                fractionalPrice: PropTypes.string,
                horseName: PropTypes.string,
                includeInMultiples: PropTypes.bool,
                isBog: PropTypes.string,
                isEachWay: PropTypes.bool,
                isEditingStake: PropTypes.bool,
                isLockedStake: PropTypes.bool,
                isSpAvailable: PropTypes.bool,
                isSpOnly: PropTypes.bool,
                isSuspended: PropTypes.bool,
                meetingId: PropTypes.string,
                outcomersId: PropTypes.string,
                priceType: PropTypes.string,
                raceDate: PropTypes.string,
                raceId: PropTypes.string,
                raceTime: PropTypes.string,
                stake: PropTypes.string,
            }),
        ).isRequired,
        options: PropTypes.arrayOf(
            PropTypes.shape({
                betSelections: PropTypes.arrayOf(
                    PropTypes.shape({}),
                ),
                betType: PropTypes.string,
                error: PropTypes.shape({}),
                isEachWay: PropTypes.bool,
                isEditingStake: PropTypes.bool,
                maxStake: PropTypes.number,
                minStake: PropTypes.number,
                numberLines: PropTypes.number,
                optionId: PropTypes.string,
                stakeValue: PropTypes.string,
            }),
        ).isRequired,
    }).isRequired,
    isMobile: PropTypes.bool.isRequired,
    currencySign: PropTypes.string.isRequired,
    setStake: PropTypes.func.isRequired,
    setIsEditingStake: PropTypes.func.isRequired,
    changeSelectionOrder: PropTypes.func.isRequired,
    setGlobalModal: PropTypes.func.isRequired,
    setMultiplesError: PropTypes.func.isRequired,
    clearMultiplesError: PropTypes.func.isRequired,
};

export default FTGroup;



// WEBPACK FOOTER //
// /src/js/drawer/components/BetPage/components/FTForm/components/FTGroup/FTGroup.jsx